import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import useProject from '@hooks/useProject';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CsImage from './CsImage';

function CsDescription() {
    const { t } = useTranslation('customerService');
    const project = useProject();
    return (
        <Fragment>
            <Column spacing={2} fullWidth>
                <Text size='headline' fontWeight='medium' color={colors.textPrimary}>
                    {t('greeting.hello')}<br/>
                    {t('greeting.welcome', { projectName: project?.name || '' })}
                </Text>
                <Text color={colors.textSecondary}>
                    {t('greeting.selectChannel')}
                </Text>
            </Column>
            <CsImage/>
        </Fragment>
    );
}

export default CsDescription;
